<template>
  <b-modal :id="modalId" :ref="modalId" :title="title" hide-footer scrollable>
    <div class="position-relative" v-for="(c, index) in data" :key="index">
      <b-row>
        <b-col cols="10" offset="2">
          <template v-if="IsComment">
            <b-icon
              icon="chat-fill"
              variant="primary"
              class="mr-2 msg-type-icon"
              font-scale="1.5"
              v-if="!c.answered_by"
            ></b-icon>
            <b-iconstack
              class="msg-type-icon"
              font-scale="1.5"
              v-if="c.answered_by"
            >
              <b-icon stacked icon="chat-fill" variant="primary"></b-icon>
              <b-icon
                stacked
                icon="chat"
                variant="primary"
                shift-h="3"
                shift-v="-1"
                flip-h
              ></b-icon>
            </b-iconstack>
          </template>
          <template v-else>
            <b-icon
              icon="envelope-fill"
              variant="primary"
              class="mr-2 msg-type-icon"
              font-scale="1.5"
              v-if="!c.answered_by"
            ></b-icon>
          </template>
          <div>{{ c.user.nickname }}</div>
          <small class="text-muted" v-if="IsComment"
            >{{ c.created_at | formatDateTime }}
          </small>
          <small class="text-muted" v-else
            >{{ c.created_date | formatDateTime }}
          </small>
          <div v-if="IsComment">
            <span :class="`text-${typeMap[c.type].variant}`">{{
              typeMap[c.type].text
            }}</span>
            {{ c.comment }}
          </div>
          <div v-else>
            {{ messageText(c) }}
          </div>
          <div class="mt-2">
            <b-btn
              v-if="c.answered_by && c.answered_by.length"
              @click="moveToAnswers(c.id)"
              size="sm"
              variant="none"
            >
              <b-icon
                icon="chat-fill"
                variant="secondary"
                font-scale="1.2"
              ></b-icon>
              <span class="ml-2"
                ><small>{{ c.answered_by.length }}</small></span
              >
            </b-btn>
          </div>
        </b-col>
      </b-row>
      <div class="text-center">
        <b-button
          variant="outline-primary"
          :disabled="allBtnDisabled"
          pill
          @click="
            c.answered_by && !c.flagged
              ? moveToAnswers(c.id, index)
              : goComment(
                  IsComment ? c.id : c.comment,
                  IsComment ? c.answer_to : c.comment_answer_to,
                  index
                )
          "
        >
          Voir votre publication concernée
          <b-spinner
            class="text-secondary"
            small
            v-if="buttonsLoading[index]"
          />
        </b-button>
      </div>
      <hr />
    </div>
  </b-modal>
</template>

<script>
/**
 * @file       Deliberation last connections modal component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  � Centre coll�gial de d�veloppement de mat�riel didactique, Coll�ge de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import { mapState } from "vuex";
import Vue from "vue";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "lastConnectionModal",
  props: {
    data: {
      required: true
    },
    title: {
      required: true
    }
  },

  /**
   * Data used in the component.
   *
   * @return  {Object}
   */
  data() {
    return {
      modalId: "lastConnectionModal",
      buttonsLoading: [],
      allBtnDisabled: false
    };
  },

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    ...mapState({
      dlibr: state =>
        state.deliberations.dlibr.data
          ? state.deliberations.dlibr.data.data.find(d => d)
          : {},
      comment: state => state.comments.comment.data
    }),
    showModal() {
      return this.dlibr.id;
    },
    typeMap() {
      return {
        1: { text: this.dlibr.positive, variant: "success", offset: 0 },
        2: { text: this.dlibr.negative, variant: "danger", offset: 2 },
        3: { text: this.dlibr.neutral, variant: "purple", offset: 1 }
      };
    },
    IsComment() {
      return this.data[0].deliberation;
    }
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    messageText(data) {
      return data.predefined_message
        ? data.predefined_message.message
        : data.message;
    },
    goComment(commentId, answereTo, index) {
      Vue.set(this.buttonsLoading, index, true);
      this.allBtnDisabled = true;
      const root = {};
      if (answereTo) {
        root.root = answereTo;
      }
      this.$store
        .dispatch("comments/getComment", {
          deliberation: this.dlibr.id,
          id: commentId,
          resourcesPerPage: 25,
          ...root
        })
        .then(() => {
          this.$store.commit("comments/setFlowDlibr", {
            reset: true,
            fields: {
              goToComment: {
                id: commentId,
                resourcesPerPage: 25
              }
            }
          });
          const params = {};
          params.teacher = this.dlibr.teacher.id;
          params.url = this.dlibr.url;
          if (answereTo) {
            params.id = answereTo;
          }
          this.$router.push({
            name: answereTo
              ? "deliberation.byUrl.answers"
              : "deliberation.byUrl",
            params
          });
        });
    },
    moveToAnswers(commentId, index) {
      Vue.set(this.buttonsLoading, index, true);
      this.allBtnDisabled = true;
      this.$router.push({
        name: "deliberation.byUrl.answers",
        params: {
          teacher: this.dlibr.teacher.id,
          url: this.dlibr.url,
          id: commentId
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.msg-type-icon {
  position: absolute !important;
  left: -25px;
  top: 5px;
}
</style>
